import {queryClient} from 'services/queryClient'
import {
  useSnapshotContext,
  SETTINGS_ENDPOINT_CONFIG_SNAPSHOT,
} from 'context/SnapshotContext'
import {
  defaultEndpointSettingsQueryResponse,
  getEndpointSettingsQueryCache,
  ENDPOINTS_SETTINGS_QUERY_KEY,
} from 'features/Settings/Endpoints/hooks/useEndpointSettingsQuery'

interface UseEndpointConfigSnapshotResult {
  endpointConfigSnapshot: typeof defaultEndpointSettingsQueryResponse
  setEndpointConfigSnapshot: (
    updatedSnapshot: typeof defaultEndpointSettingsQueryResponse,
  ) => void
  resetToEndpointConfigSnapshot: () => void
}

export const useEndpointConfigSnapshot =
  (): UseEndpointConfigSnapshotResult => {
    const {snapshot, setSnapshot} = useSnapshotContext()

    const endpointConfigSnapshot = snapshot?.[
      SETTINGS_ENDPOINT_CONFIG_SNAPSHOT
    ] as typeof defaultEndpointSettingsQueryResponse

    const handleUpdateSnapshot = (
      updatedSnapshot: typeof defaultEndpointSettingsQueryResponse,
    ): void => {
      setSnapshot({
        ...snapshot,
        [SETTINGS_ENDPOINT_CONFIG_SNAPSHOT]: updatedSnapshot,
      })
    }

    const handleResetToSnapshot = (): void => {
      const endpointsSettingConfig = getEndpointSettingsQueryCache()
      if (!endpointConfigSnapshot) {
        return
      }
      const payload = {
        ...endpointsSettingConfig,
        data: endpointConfigSnapshot,
      }
      queryClient.setQueryData([ENDPOINTS_SETTINGS_QUERY_KEY], payload)
    }

    return {
      endpointConfigSnapshot,
      setEndpointConfigSnapshot: handleUpdateSnapshot,
      resetToEndpointConfigSnapshot: handleResetToSnapshot,
    }
  }
